import { useEffect, useMemo, useState } from 'react';
import { Col, Form, InputGroup, Row } from 'react-bootstrap';
import ToggleButton from 'components/Buttons/ToggleButton';
import Base from 'antd/es/typography/Base';

const DeviceSetting = ({
  settingName,
  settingDataName,
  setting,
  metric,
  min = -Infinity,
  max = Infinity,
  turnOffAt,
  step = 1,
  deviceSettings,
  handleInputChange,
  device,
  type,
  enabled = true,
  toggleEnabled = true,
  restoreValue = null,
}) => {
  const [inputValue, setInputValue] = useState(setting);

  useEffect(() => {
    setInputValue(setting);
  }, [setting]);

  const coerceToDisplayType = (value) => {
    if (value === null || value === undefined) return value;

    if (typeof setting === 'string') {
      return typeof value === 'string' ? value : value.toString();
    }

    const numeric = Number(value);
    return Number.isNaN(numeric) ? value : numeric;
  };

  const normalizeForCompare = (value) => {
    if (value === null || value === undefined || value === '') return null;
    if (typeof value === 'boolean') return value ? 1 : 0;

    const numeric = Number(value);
    return Number.isNaN(numeric) ? value : numeric;
  };

  const resolvedRestoreValue = useMemo(() => {
    const preferred = restoreValue !== null && restoreValue !== undefined ? restoreValue : setting;

    let candidate = preferred !== null && preferred !== undefined ? preferred : (step ?? 0);

    if (
      turnOffAt !== null &&
      turnOffAt !== undefined &&
      normalizeForCompare(candidate) === normalizeForCompare(turnOffAt)
    ) {
      candidate = step ?? 0;
    }

    return coerceToDisplayType(candidate);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [restoreValue, setting, step, turnOffAt]);

  const handleBlur = (e) => {
    let value = e.target.value;

    switch (type) {
      case 'int':
        value = parseInt(value, 10);
        break;
      case 'float':
        value = parseFloat(value);
        break;
      case 'string':
        value = value.toString();
        break;
      default:
        break;
    }

    handleInputChange(settingDataName, value);
  };

  const isOff = useMemo(
    () => (turnOffAt === null ? setting === null : setting === turnOffAt),
    [setting, turnOffAt],
  );

  const onToggleClick = () => {
    if (!enabled) return;

    if (isOff) {
      handleInputChange(settingDataName, resolvedRestoreValue);
    } else {
      handleInputChange(settingDataName, turnOffAt);
    }
  };

  return (
    <Row className="align-items-center g-2 mb-2">
      <Col lg={6} className="d-flex align-items-center gap-2">
        <label className="fw-semibold mb-0">{settingName}:</label>
      </Col>

      <Col lg={6} className="d-flex align-items-center gap-2">
        <div className="d-flex flex-column flex-sm-row align-items-center gap-2 border-0">
          {toggleEnabled && (
            <ToggleButton isOff={isOff} onClick={onToggleClick} enabled={enabled} />
          )}

          {(!isOff || !toggleEnabled) && (
            <InputGroup className="flex-nowrap align-items-stretch" style={{ width: 140 }}>
              <Form.Control
                className="bg-primary border-0"
                disabled={!enabled}
                type="number"
                value={inputValue}
                min={min}
                max={max}
                step={step}
                onChange={(e) => setInputValue(e.target.value)}
                onBlur={handleBlur}
                style={{ paddingLeft: 10, paddingRight: 10 }}
              />
              <InputGroup.Text className="text-dark bg-white border-0 px-1">
                {metric}
              </InputGroup.Text>
            </InputGroup>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default DeviceSetting;
